import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=d097cf62&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=ts&"
export * from "./BasicLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d097cf62",
  null
  
)

export default component.exports